<template>
    <div class="px-3">   
        <div class="row">
            <div class="col-xs-5 col-sm-2">
                <v-btn small class="ma-0" @click="$router.back()" color="info" outlined> 
                    <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras 
                </v-btn>   
            </div> 
            <div class="col-xs-5 col-sm-8 text-center ">
                <h5 class="xblue darken-4 py-2">
                    <b class="xwhite--text"> Indicar visibilidad y estado en oferta academica de cada proyecto </b>
                    <p class="mb-0">para que aparezca en oferta: debe tener posgrado, estado y estar disponible</p>
                </h5>
            </div>
        </div> 
        <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            placeholder="buscar por codigo..."
            color="green"
            single-line
            dense
            filled
            hide-details />
        <v-btn small class="ma-0" @click="getDatos()" color="info" outlined> 
            <v-icon>mdi-refresh</v-icon> 
        </v-btn>  
        <v-data-table
            :headers="headers"
            :items="desserts"
            :loading="loading" 
            :search="search"
            dense
            xdisable-pagination 
            xhide-default-footer
            :items-per-page-options="[5,13,30,-1]"
            :items-per-page="13"
            class="elevation-0">
    
            <template v-slot:[`item.ind`]="a">
                <span> {{ a.index + 1 }} </span>
            </template>
            <template v-slot:[`item.proyecto_fecha_aprobacion`]="{item}">
                <span> {{ parseFecha(item.proyecto_fecha_aprobacion) }} </span>
            </template>
            <template v-slot:[`item.fecha_inicio`]="{item}">
                <span> {{ parseFecha(item.fecha_inicio) }} </span>
            </template>
            <template v-slot:[`item.fecha_fin`]="{item}">
                <span> {{ parseFecha(item.fecha_fin) }} </span>
            </template> 
            <template v-slot:[`item.estado_oferta`]="{item}"> 
                <span v-if="item.estado_oferta=='AUTORIA'" class="green--text"> {{ item.estado_oferta }} </span>
                <span v-else-if="item.estado_oferta=='LIBRE'" class="orange--text"> {{ item.estado_oferta }} </span>
                <span v-else-if="item.estado_oferta=='ESTRELLA'" class="purple--text"> {{ getlabel }} </span>
                <small v-else>  </small>
            </template> 
            <template v-slot:[`item.disponible_para_oferta`]="{item}">
                <p class="text-center ma-0" >
                    <v-badge dot :color="item.disponible_para_oferta?'green':'red'" />
                </p>
            </template>  
            <template v-slot:[`item.opt`]="{item}">
                <v-menu offset-x offset-y>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn class="my-0 py-0" color="primary" outlined small dark v-bind="attrs" v-on="on">
                            <v-icon>mdi-menu</v-icon>
                        </v-btn>
                    </template>
                    <v-list> 
                        <v-list-item v-if="!item.postgrado_id" link @click="crearPosgrado(item)">
                            <v-list-item-title>
                                <v-icon>mdi-file</v-icon>
                                Crear posgrado
                            </v-list-item-title>
                        </v-list-item>
                        <v-list-item link @click="cambiarEstadoOferta(item)">
                            <v-list-item-title>
                                <v-icon>mdi-share</v-icon>
                                Estado oferta
                            </v-list-item-title>
                        </v-list-item> 
                        <v-list-item link @click="cambiarOfertar(item)">
                            <v-list-item-title>
                                <v-icon>mdi-pin</v-icon>
                                Cambiar disponibilidad
                            </v-list-item-title>
                        </v-list-item>  
                    </v-list>
                </v-menu> 
            </template>
        </v-data-table> 
 
        <EstadoOfer ref="refEstadoOfer"/>
        <crearPosgrado ref="refCrearPosgrado" v-on:onsuccess="onsuccess" />
    </div>
</template>
  
<script>
import xaxios from '@/xaxios';
import {parseFecha, parseDateFecha} from '../util.ts'
import EstadoOfer from './ventanita-estados.vue'
import crearPosgrado from '../autoria/crear-posgrado.vue';

export default {
    components: {EstadoOfer,crearPosgrado}, 
    data() {
        return {
            loading: false, 
            headers: [ 
                { text: '#', value: 'ind' },
                { text: 'Programa', value: 'programa_nombre', width:'370' },
                { text: 'Sede proyecto', value: 'sede', width:'115' },
                { text: 'Codigo', value: 'codigo', width:'120' },
                { text: 'Aprobado', value: 'proyecto_fecha_aprobacion' },
                { text: 'Resolucion', value: 'resolucion_aprobacion_universidad' },
                { text: 'proyecto', value: 'proyecto_id' }, 
                { text: 'postgrado', value: 'postgrado_id' }, 
                { text: 'estado oferta', value: 'estado_oferta' }, 
                { text: 'disponible seleccionar', value: 'disponible_para_oferta' }, 
                { text: '', value: 'opt' },
            ], 
            desserts: [],
            aprobados: [],
            parseFecha,
            parseDateFecha,  
            filtros:{
                mes:null,
                anio: null,
            },  
            search: '',
            periodo_dis:''
        };
    },
    watch: {
        '$store.state.CARGO': function( ){  
            this.getDatos();
        }, 
    },
    computed:{
        getlabel(){
            const sid = this.$store.state.CARGO.sede.unidad_negocio;
            if(sid == 1) return 'ESTRELLA'
            return 'ALTO RENDIMIENTO'
        }
    },
    methods: {
        async getDatos(){
            const unidad = this.$store.state.CARGO.sede.unidad_negocio;
            const sede = this.$store.state.CARGO.sede.id;
            let ps = `ofertas-academicas/para-regular?unidad_negocio_id=${unidad}&sede_id=`+sede;
            const url = process.env.VUE_APP_URL_API_PAGOS2+ps;
            this.desserts = [];
            this.loading = true;
            const res = await xaxios.get(url).then(({data})=>data).catch(e=>e);
            // window.console.log('res', res);
            if(res) {
                this.desserts = res.datos;
            }
            this.loading = false; 
        }, 
        onseleccionado(){
            this.$emit('onsuccessseleccionado'); 
        }, 
        async getGestiones() {  
            const d = new Date();
            const m = d.getMonth()+1;
            const anio = d.getFullYear(); 

            this.filtros.mes = m; 
            this.filtros.anio = anio;  
            
            this.getDatos(); 
        },

        crearPosgrado(proy){
            this.$refs.refCrearPosgrado.openmodal(proy);
        },
        onsuccess(proy, post, post2){
            // window.console.log('onsucess posgrado:::', proy,post);
            const p = post.datos[0];
            const p2 = post2.datos[0];
            proy.postgrado_id = p.postgradoId; 
            proy.disponible_para_oferta = p2.disponibleParaOferta; 
        },

        async cambiarOfertar(item){ 
            window.console.log('cambiarOfertar:', item);
            if(!item.postgrado_id){
                this.$root.$notify.show(`Falta el posgrado`, {color:'red',x: 'right',});
                return;
            }
            let url = process.env.VUE_APP_URL_API_PAGOS2+'programa-universidad/vincular/update-disponible-para-oferta';
          
            const xin = { 
                proyectoId: item.proyecto_id,
                ofertar: item.disponible_para_oferta? 0: 1,
            };

            // let raw = JSON.stringify(xin);
            let resp = await xaxios.post(url,xin).then(d=>d).catch(e=>e);
            window.console.log('resp',resp);


            /*let resp = await fetch(url, {
                method: "POST",
                headers: {
                "Content-Type": "application/json" 
                },
                body: JSON.stringify(xin)
            }).then(response => response.json()).then(data => data).catch(error => error);*/

            window.console.log('>>>', resp);
            item.disponible_para_oferta = xin.ofertar;
            this.$root.$notify.show(resp.mensaje, {color:'purple',x: 'right',timeout:1200});
        },

        async cambiarEstadoOferta(item){
            if(!item.postgrado_id){
                this.$root.$notify.show(`Falta el posgrado`, {color:'red',x: 'right',});
                return;
            }
            const r = await this.$refs.refEstadoOfer.openmodal(item);
            if(!r) return;
            let url = process.env.VUE_APP_URL_API_PAGOS2+'programa-universidad/vincular/update-estado-para-oferta';
          
            
            const xin = { 
                proyectoId: item.proyecto_id, 
                estado_ofertar: r,
            };
            
            let resp = await xaxios.post(url,xin).then(d=>d).catch(e=>e);
            window.console.log('resp',resp);

            /*let resp = await fetch(url, {
                method: "POST",
                headers: {
                "Content-Type": "application/json"
                },
                body: JSON.stringify(xin)
            }).then(response => response.json()).then(data => data).catch(error => error);*/

            window.console.log('>>>', resp);
            item.estado_oferta = r;
            this.$root.$notify.show(resp.mensaje, {color:'purple',x: 'right',timeout:1200});
        }
    },
    mounted() { 
        this.desserts = []; 
        this.getGestiones();  
    },
};
</script>
  